import { cn } from '@/shared/lib/utils';
import type { ComponentProps } from 'react';

export type BottomTabRootProps = ComponentProps<'div'> & {
  children: React.ReactNode;
  hideShadow?: boolean;
  /** Cinco abas (com o Clube pratiGO): menos margem lateral para caber tudo. */
  dense?: boolean;
};

export function BottomTabRoot({ children, hideShadow = false, dense = false }: BottomTabRootProps) {
  return (
    <div
      className={cn(
        'flex bg-white items-center justify-between h-18 px-9 py-2 shadow-[0_-5px_12px_-1px_rgba(0,0,0,0.06)]',
        dense && 'px-4',
        hideShadow && 'shadow-none'
      )}
    >
      {children}
    </div>
  );
}
